import { render, staticRenderFns } from "./InfoMenu.vue?vue&type=template&id=4ff23ffc&"
import script from "./InfoMenu.vue?vue&type=script&lang=js&"
export * from "./InfoMenu.vue?vue&type=script&lang=js&"
import style0 from "./InfoMenu.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAppBar } from 'vuetify/lib/components/VAppBar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
installComponents(component, {VAppBar,VCard,VTab,VTabs})
